import React from "react";
import {
  ListItemContainerRow,
  ListItemText,
  ListItemDate,
  EventItemPostMeta,
  EventItemContainer,
  EventItemDetailHeader,
  EventItemTitle,
  EventShareButtonsCol,
  EventItemBodySection,
} from "../../utils/common-styles";
import { MarkdownDisplay } from "../Extra/MarkdownDisplay";
import { Row} from "react-bootstrap";
import {Helmet} from "react-helmet";
import { ShareButtons } from "../Extra/ShareButtons";
import GalleryWidget from "../../components/Extra/GalleryWidget";
import { DownloadsWidget } from "../../components/Extra/DownloadsWidget";
import {UrlFixer} from "../../utils/utils";

export const EventItemDetail = ({ post }) => {
  const eventItem = post;

  return (
    <>
      <Helmet>
        <title>{eventItem.title}</title>
        <meta name="description" content={eventItem.intro?.substring(0, 155)} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={eventItem.title} />
        <meta property="og:description" content={eventItem.intro?.substring(0, 155)} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={UrlFixer('/og-large-profile.jpg')} />
      </Helmet>
      <EventItemContainer>
        <EventItemDetailHeader>
        <ListItemContainerRow>
          <ListItemDate xs={12} md={3} className="event-date">
            <h4>
              {new Date(eventItem.starts_at_date).toLocaleString("default", {
                month: "long",
              })}
            </h4>
            <span className="daynum">
              <h1>{new Date(eventItem.starts_at_date).toLocaleString("default", {
                day: "numeric",
              })}</h1>
            </span>
          </ListItemDate>
          <ListItemText>
            <EventItemTitle>
              <h2>{eventItem.title}</h2>
            </EventItemTitle>
            <section>
              <MarkdownDisplay text={eventItem.intro} plugins={[]} />
            </section>
          </ListItemText>
          <EventItemPostMeta className="post-meta">
          <Row>
            <EventShareButtonsCol xs={12} md={12}>
              <ShareButtons title={eventItem.title} shareUrl={window.location.href} />
            </EventShareButtonsCol>
          </Row>
        </EventItemPostMeta>
        </ListItemContainerRow>
        </EventItemDetailHeader>
        <EventItemBodySection>
          <MarkdownDisplay text={eventItem.body} plugins={[]} />
        </EventItemBodySection>
        <GalleryWidget images={eventItem.gallery_details} />
        {eventItem.documents && eventItem.documents.length > 0 && <DownloadsWidget downloads={eventItem.documents} />}
      </EventItemContainer>
    </>
  );
};
